import {
  ColumnProps,
  consoleTableMixin,
  DangerLink,
  modalDanger,
  Table,
  TableProps,
  UserAvatar,
} from 'admin-web-ui'
import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'
import { UserKeyInfo } from '../user-key-info'

function makeColumns(opts: {
  onRevoke: RevokeHandler
  isAdmin: boolean
}): ColumnProps<UserKeyInfo>[] {
  return [
    {
      ellipsis: true,
      key: 'owner',
      title: 'Owner',
      dataIndex: 'firstName',
      render(_, userKeyInfo) {
        return <UserAvatar userInfo={userKeyInfo} />
      },
    },
    {
      key: 'keyId',
      title: 'Key ID',
      dataIndex: 'id',
    },
    {
      key: 'actions',
      title: <span style={{ visibility: 'hidden' }}>{'Actions'}</span>,
      dataIndex: 'id',
      align: 'right',
      width: '130px',
      render(_, userKeyInfo) {
        return (
          <DangerLink
            onClick={() =>
              opts.onRevoke(opts.isAdmin ? userKeyInfo.sub : userKeyInfo.id)
            }
            className="automation-RevokeKeyButton"
          >
            Revoke Key
          </DangerLink>
        )
      },
    },
  ]
}

export type RevokeHandler = (keyId: string) => void

const UserKeyInfoTable = Table as React.FC<TableProps<UserKeyInfo>>

const StyledConsoleTable = styled(UserKeyInfoTable)`
  ${consoleTableMixin}
  margin: -24px;
  max-width: inherit;
  & tr > td,
  tr > th {
    padding: 16px 24px;
  }
  ul.ant-pagination.ant-table-pagination {
    margin-right: 24px;
  }
`

interface Props {
  dataSource: UserKeyInfo[]
  loading?: boolean
  onRevoke: RevokeHandler
  isAdmin: boolean
}

export const TestRegistrationKeyList: React.FC<Props> = (props) => {
  const { onRevoke } = props

  const revokeButtonHandler = useCallback(
    (keyId: string): void => {
      modalDanger({
        title: 'Revoke Test Registration Key',
        content: (
          <p>
            Revoking a Test Registration Key cannot be undone. When this key is
            revoked it will no longer work. Are you sure you wanted to revoke
            this Test Key?
          </p>
        ),
        onOk: () => onRevoke(keyId),
      })
    },
    [onRevoke],
  )

  const columns = useMemo(
    () =>
      makeColumns({
        onRevoke: revokeButtonHandler,
        isAdmin: props.isAdmin,
      }),
    [revokeButtonHandler, props.isAdmin],
  )

  return (
    <StyledConsoleTable
      loading={props.loading}
      columns={columns}
      dataSource={props.dataSource}
      rowKey="id"
    />
  )
}
